import type {Bag, JobInputIndex} from "../services/classes/Bag";

export type DatabagRouteMatch = {id: string};
export type DataFileRouteMatch = {dataFileId: string,};
export type TaxonomyRouteMatch = {id: string, taxonomyId: string};
export type CmpDataBagRouteMatch = {id: string, id2: string};
export type ApprovalRouteMatch = {approvalId: string};
export type Supplier360RouteMatch = {id: string, supplierId: string};
export type CategoryProfileRouteMatch = {id: string, tab: string};
export type OpportunityRouteMatch = {id: string, oppId: string};
export type MithraHistoryState = undefined | {
    bag: Bag,
    bag2?: Bag,
    selected_job_input: JobInputIndex, // Not used yet
};
export type TaxonomySuggestorRouteMatch = {id: string, taxonomyId: string, taxonomySuggestorId?: string,};

export type AnyRouteMatch =
    {"*": null} // React Router V7
    & (
    DatabagRouteMatch
    | DataFileRouteMatch
    | TaxonomyRouteMatch
    | CmpDataBagRouteMatch
    | ApprovalRouteMatch
    | TaxonomySuggestorRouteMatch
    );

const r = {
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Mithra app V3.0 urls
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    homepage_dashboard: '/data/:id/dashboard',

    master_supplier_agreement: '/data/:id/master-supplier-agreement',
    payment_terms: '/data/:id/payment-terms',
    payment_terms_v2: '/data/:id/payment-terms-v2',
    contract_explorer: '/data/:id/contract-explorer',

    // Prototypes (see src/prototypes/AGENTS.md)
    prototype_taxonomy_canvas: '/data/:id/prototypes/taxonomy-canvas',
    prototype_taxonomy_canvas_approval: '/data/:id/prototypes/taxonomy-canvas/approval',

    cleanup_taxonomy_builder: '/data/:id/cleanup/taxonomy-builder',
    cleanup_taxonomy_builder_id: '/data/:id/cleanup/taxonomy-builder',
    cleanup_categorization: '/data/:id/cleanup/categorization',
    cleanup_golden_record: '/data/:id/cleanup/material-harmonisation',

    adv_dashboard: '/data/:id/spend-landscape',
    analytics_koi_ss: '/data/:id/analytics/supplier-segmentation',
    analytics_koi_kdf: '/data/:id/analytics/categories',
    analytics_koi_ppv: '/data/:id/analytics/price-variance',
    analytics_koi_ppv_opportunities: '/data/:id/analytics/price-variance/opportunities',
    analytics_koi_ppv_opportunity_detail: '/data/:id/analytics/price-variance/:oppId',
    analytics_koi_sc: '/data/:id/analytics/spend-concentration',

    approval: '/approval',
    approval_cat_detail: '/approval/category/:approvalId',
    approval_tax_detail: '/approval/taxonomy/:approvalId',
    approval_plan_detail: '/approval/category-plan/:approvalId',

    chat: '/c/:id/chat',
    chat_download: '/c/:id/chat/download/:filename',
    supplier_360: '/data/:id/supplier-360',
    // Mithra staff only: which detail tabs this environment shows.
    supplier_360_settings: '/data/:id/supplier-360/settings',
    // Explore Categories and the Category Profile (CAT-2191). The category is the `?path=L1|L2` query.
    category_explore: '/data/:id/categories',
    category_profile: '/data/:id/categories/profile/:tab',
    category_settings: '/data/:id/categories/settings',
    // Retired Supplier Normalization page; kept only to redirect old links to Supplier 360.
    // Support ends March 2027.
    legacy_supplier_normalization: '/data/:id/cleanup/supplier-normalization',
    contract_coverage_intelligence: '/data/:id/contract-coverage-intelligence',
    // contract_coverage_intelligence_v2: '/data/:id/contract-coverage-intelligence/v2',

    // Dashboards module: Built-in (Hermes) + Yours (DashGen). `:id` is the databag (Yours is databag-scoped).
    dashboards: '/c/:id/dashboards',
    dashboards_detail: '/c/:id/dashboards/:source/:dashboardId',

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Demo urls
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    demo_business_case_report: '/d/:id/business-case-report',
    demo_business_case_report_id: '/d/:id/business-case-report/:businessCaseId',
    demo_manage: '/d/:id/manage',

    demo_koi_cfo: '/d/:id/cash-flow-optimization',
    demo_koi_sh: '/d/:id/supplier-hierarchy',

    demo_cleanup_taxonomy_health_check: '/d/:id/cleanup/taxonomy-builder/health-check',
    demo_cleanup_taxonomy_suggestion_v1: '/d/:id/cleanup/taxonomy-builder/suggestion-single',
    demo_cleanup_taxonomy_suggestion_v2: '/d/:id/cleanup/taxonomy-builder/suggestion',

    demo_merge_taxonomy_suggester: '/d/:id/merge/taxonomy-suggester',
    demo_merge_taxonomy_mapper: '/d/:id/merge/taxonomy-mapper',
    demo_merge_taxonomy_mapper_review: '/d/:id/merge/taxonomy-mapper/review',
    demo_report: '/d/:id/synergy/report',

    demo_opportunities: '/d/opportunity',
    demo_opportunities_id: '/d/:id/opportunity',

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Other urls
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    home: '/' as const,
    login: '/login' as const,
    frontegg_callback: '/oauth/callback' as const,

    // data-ingestion
    data_ingestion: '/data-ingestion',
    data_upload_mapping: '/data-upload/:dataFileId',
    data_upload: '/data-upload',

    // taxonomy-ingestion
    taxonomy_ingestion: '/taxonomy-ingestion',
    taxonomy_upload_mapping: '/taxonomy-upload/:dataFileId',
    taxonomy_upload: '/taxonomy-upload',

    test_small_ppv_component: '/test/small-ppv-component',
    test_react_integration: '/test/react-integration',
}

export const catRoutes = r;
